import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

export default function Checkbox({ checked, disabled, onClick, round }) {
  const checkedClassName = checked ? 'Checkbox--checked' : '';
  const disabledClassName = disabled ? 'Checkbox--disabled' : '';
  const roundClassName = round ? 'Checkbox--round' : '';

  return (
    <div
      className={`Checkbox ${checkedClassName} ${disabledClassName} ${roundClassName}`}
      onClick={disabled ? () => {} : onClick}
    >
      <div />
    </div>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  round: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
  onClick: () => {},
  round: false,
};
